export default {
  meta: {
    title: '设置复盘规则',
  }
};
